// extracted by mini-css-extract-plugin
var _1 = "t2sZ";
var _2 = "t2sY";
export { _1 as "close", _2 as "title" }
